var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('map-device',{attrs:{"source-data":_vm.source}},[_c('PopupDevice',{attrs:{"coordinates":[60.260494351387027, 59.943620275388454],"device":{
				name: 'Test Popup with very long long long long long long long long long name',
				address: 'Central mall, Przhevalsky street 12, Smolensk, Russia',
				type: 3,
			}}})],1),_c('button',{attrs:{"type":"button"},on:{"click":_vm.changePoints}},[_vm._v("change points")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }